module.exports = __webpack_public_path__ + "images/fa-career-certificate.jpg";